












    import Vue from 'Vue';
    import navigationItem from './navigationItem.vue';
    import { INavigationItem} from '../../../../../../CommonScripts/Abstractions';
    export default Vue.extend({
        name: 'navigation-drawer',
        props: {
            cssClass: { type: String, required: false }
        },
        data(): { selectedItem: number } {
            return { selectedItem: null}
        },
        components: {'navigation-item': navigationItem},
        computed: {
            navigationVisible(): boolean {
                return this.$store.state.ui.navDrawerVisible;
            }
        },
        watch: {
            navigationVisible: {
                handler: function () {
                    this.$nextTick(function () {
                        setTimeout(() => {//nasty hack, but just waiting for the dom update cycle doesn't show the selected item
                            if (this.navigationVisible && this.selectedItem !== null) {
                                const ref = this.$refs[this.selectedItem] as (Vue & { $el: any })[]
                                ref[0].$el.focus();
                            }
                        }, 500);

                    });
                }
            }
        },
        methods: {
            clicked() {
                this.$store.commit('ui/setNavDrawerVisible', false);
            }
        }

    });
